export default "__VITE_ASSET__7ef5ec51__"